import { GridButton } from '@eforall/dashboard';
import { EntrepreneurProspectDialogDataService } from '../../entrepreneur-prospect-dialog-data.service';


export function getButtons(entrepreneurProspectDialogDataService: EntrepreneurProspectDialogDataService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => {
				await entrepreneurProspectDialogDataService.reloadData();
			}
		},
	];

	return buttons;
}